import type { SymbolDefinition } from "../types.ts";

export const powerSupply: SymbolDefinition = {
  id: "ep-psu",
  familyKey: "power_supply",
  deviceKind: "power_supply",
  version: "0.1.0",
  label: { sv: "Nätaggregat", en: "Power supply" },
  description: { sv: "AC/DC nätaggregat.", en: "AC/DC power supply." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="6" y="10" width="36" height="28" rx="2"/>
      <text x="16" y="28" text-anchor="middle" font-size="6" fill="currentColor" stroke="none">AC</text>
      <text x="32" y="28" text-anchor="middle" font-size="6" fill="currentColor" stroke="none">DC</text>
      <line x1="12" y1="2" x2="12" y2="10"/>
      <line x1="24" y1="2" x2="24" y2="10"/>
      <line x1="36" y1="38" x2="36" y2="46"/>
      <line x1="12" y1="38" x2="12" y2="46"/>
    </g>
  `,
  terminals: [
    { id: "L", kind: "phase", label: "L", position: "top", offset: 0.25 },
    { id: "N", kind: "neutral", label: "N", position: "top", offset: 0.5 },
    { id: "V+", kind: "control", label: "+", position: "bottom", offset: 0.75 },
    { id: "V-", kind: "control", label: "-", position: "bottom", offset: 0.25 },
  ],
  designationPrefix: "G",
  searchKeywords: ["nätaggregat", "psu", "power supply"],
};
